// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__KHBC6","image":"Header_image__13qpp","name":"Header_name__ZcYxa","info":"Header_info__3LnRI","infoRow":"Header_infoRow__3SnfI"};